
import {route as auth} from '../modulos/auth'
import {route as home} from '../modulos/home'
import {route as trabalhador} from '../modulos/trabalhador'
import {route as depedentes} from '../modulos/depedentes'
import {route as tomador} from '../modulos/tomador'
import {route as taxa} from '../modulos/taxa'
import {route as tabelapreco} from '../modulos/tabelapreco'
import {route as tabelaprecorublica} from '../modulos/tabelaprecorublica'
import {route as comissionado} from '../modulos/comissionador'
import {route as boletinstabela} from '../modulos/boletins/tabela'
import {route as boletinscartaoponto} from '../modulos/boletins/cartaoponto'
import {route as boletinstabelatrabalhadores} from '../modulos/boletins/tabela/trabalhadores'
import {route as boletinscartaopontotrabalhadores} from '../modulos/boletins/cartaoponto/trabalhadores'
import { route as inss } from "../modulos/inss";
import { route as irrf } from "../modulos/irrf";
import { route as vale } from "../modulos/vale";
import { route as folhar } from "../modulos/folhar";
import { route as fatura } from "../modulos/fatura";
import { route as rescisaocontrator } from "../modulos/rescisaocontrator";
import { route as backup } from "../modulos/backup";
import { route as acidentetrabalhor } from "../modulos/trabalhador/sst/acidentetrabalhor";
import { route as saudetrabalhor } from "../modulos/trabalhador/sst/saudetrabalhador";
import { route as ambientetrabalhor } from "../modulos/trabalhador/sst/ambientetrabalhor";
import { route as avuso } from "../modulos/avuso";
import { route as cartademissao } from "../modulos/cartademissao";
import { route as dstavulso } from "../modulos/dstavulso";
import { route as ferias } from "../modulos/ferias";
import { route as decimo } from "../modulos/decimo";
import { route as rubrica } from "../modulos/rubrica";
import { route as aplicativo } from "../modulos/app";
import { route as folharaplicativo } from "../modulos/folhar/page/aplicativo";
import { route as folharverpagamento } from "../modulos/folhar/page/verpagamento";
import { route as folharverpagamentotomador } from "../modulos/folhar/page/verpagamento/tomador";
import { route as categoria } from "../modulos/categoria";
import { route as cbo } from "../modulos/cbo";
import { route as cargohoraria } from "../modulos/cargohoraria";
import { route as trabalhadorlotacao } from "../modulos/trabalhador/lotacao";
import { route as trabalhadorafastamento } from "../modulos/trabalhador/afastamento";
import { route as trabalhadorcontrato } from "../modulos/trabalhador/contrato";
import { route as trabalhadordesligamento } from "../modulos/trabalhador/desligamento";
import { route as trabalhadorcessao } from "../modulos/trabalhador/cessao";
import { route as trabalhadorcomissionado } from "../modulos/trabalhador/comissionado";
import { route as trabalhadorreintegracao } from "../modulos/trabalhador/reintegracao";
import { route as trabalhadoradvertencia } from "../modulos/trabalhador/advertencia";
import { route as trabalhadornotas } from "../modulos/trabalhador/notas";
import { route as trabalhadorvaletransporte } from "../modulos/trabalhador/valetransporte";
import { route as trabalhadorvalealimentacao } from "../modulos/trabalhador/valealimentacao";
import {route as tabelaprecorublicaevento} from '../modulos/tabelaprecorublica/esocial';
import {route as folharevento} from '../modulos/folhar/page/esocial'
import {route as folharevento1270} from '../modulos/folhar/page/esocial/evento1270'
import { route as desligamentotabelapreco } from "../modulos/trabalhador/desligamento/tabelapreco";
import { route as folhartaxas } from "../modulos/configuracao/folha/taxas";
import { route as certificado } from "../modulos/certificado";
import { route as empresa } from "../modulos/empresa";
import { route as trabalhadorbackup } from "../modulos/configuracao/trabalhador/backup";
import { route as tomadorbackup } from "../modulos/configuracao/tomador/backup";
import { route as tabelaprecobackup } from "../modulos/configuracao/tabelapreco/backup";
import { route as boletimbackup } from "../modulos/configuracao/boletim/backup";
import {route as epi} from '../modulos/trabalhador/epi'
import {route as usuario} from '../modulos/usuarios'
import {route as alerta} from '../modulos/aviso';
export default [
    ...auth,
    ...home,
    ...trabalhador,
    ...depedentes,
    ...tomador,
    ...taxa,
    ...tabelapreco,
    ...tabelaprecorublica,
    ...comissionado,
    ...boletinstabela,
    ...boletinstabelatrabalhadores,
    ...inss,
    ...irrf,
    ...vale,
    ...folhar,
    ...fatura,
    ...boletinscartaoponto,
    ...boletinscartaopontotrabalhadores,
    ...rescisaocontrator,
    ...backup,
    ...acidentetrabalhor,
    ...avuso,
    ...cartademissao,
    ...dstavulso,
    ...ferias,
    ...decimo,
    ...rubrica,
    ...aplicativo,
    ...folharaplicativo,
    ...categoria,
    ...cbo,
    ...cargohoraria,
    ...trabalhadorlotacao,
    ...trabalhadorafastamento,
    ...trabalhadorcontrato,
    ...trabalhadordesligamento,
    ...trabalhadorcessao,
    ...trabalhadorcomissionado,
    ...trabalhadorreintegracao,
    ...trabalhadoradvertencia,
    ...trabalhadornotas,
    ...tabelaprecorublicaevento,
    ...folharevento,
    ...desligamentotabelapreco,
    ...trabalhadorvalealimentacao,
    ...trabalhadorvaletransporte,
    ...folharverpagamento,
    ...folhartaxas,
    ...certificado,
    ...empresa,
    ...trabalhadorbackup,
    ...epi,
    ...saudetrabalhor,
    ...ambientetrabalhor,
    ...tomadorbackup,
    ...tabelaprecobackup,
    ...boletimbackup,
    ...folharverpagamentotomador,
    ...folharevento1270,
    ...usuario,
    ...alerta
]
